import { Pagination, Table } from "antd";
import {FormattedMessage, useIntl} from "react-intl";
import { useHistory } from "react-router";
import Spinner from '../../../components/Spinner/Spinner';
import { pageSize, useSurvey } from "./useSurvey";
import { Props, TableData, TabStatus } from "./Survey.model";
import styles from "./Survey.module.scss";
import ErrorMessage from "../../../components/ErrorMessage/ErrorMessage";

const Survey = ({filters}: Props) => {
	const { getSurveys, onChangeHistorySurveysPagination, state } = useSurvey({filters});
	const { historySurveys, tabStatus, historySurveysPagination } = state;
	const intl = useIntl();
	const history = useHistory();

	const surveyColumns = [
			{
			dataIndex: 'surveyType',
				render: (type: string) => (
					<FormattedMessage id={`surveyType.${type}`} />
				),
			title: intl.formatMessage({ id: 'table.column.surveyType' }),
		},
		{
			dataIndex: 'date',
			title: intl.formatMessage({ id: 'table.column.date' }),
		},
	];
	
	const onSurveyRow = (rowData: TableData) => {
		return {
			onClick: () => {
				history.push(`/surveys/${rowData.id}`);
			},
		};
	};


	return <div className={styles.tabContent}>
		<Spinner spinning={tabStatus === TabStatus.Loading} />
		<ErrorMessage error={tabStatus === TabStatus.Error} onRefresh={getSurveys} showReport={false}/>
		<Table
			columns={surveyColumns}
			dataSource={historySurveys}
			pagination={false}
			onRow={onSurveyRow}
		/>
		<div className={styles.paginationWrapper}>
			<Pagination
				className={styles.pagination}
				current={historySurveysPagination.page}
				pageSize={pageSize}
				total={historySurveysPagination.total}
				onChange={onChangeHistorySurveysPagination}
			/>
		</div>
	</div>
};
export default Survey;